import { render, staticRenderFns } from "./CreateIndex.vue?vue&type=template&id=4abad0f6&lang=pug&"
import script from "./CreateIndex.vue?vue&type=script&lang=ts&"
export * from "./CreateIndex.vue?vue&type=script&lang=ts&"
import style0 from "./CreateIndex.vue?vue&type=style&index=0&id=4abad0f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports